// extracted by mini-css-extract-plugin
module.exports = {"block":"grdoO","inner":"OYYro","content":"PCxMe","title":"nOTX5","description":"_6uDZJ","more":"tAxRt","icon":"Y04mF"};